/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const SwitcherIcon = /*#__PURE__*/ createSvgIcon(
  'SwitcherIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M8.125 13.25H2.75a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h5.375l-1.667-1.667a.733.733 0 010-1.062.733.733 0 011.063 0l2.958 2.958a.756.756 0 01.208.525c0 .1-.017.194-.052.281a.69.69 0 01-.156.236l-2.958 2.958a.663.663 0 01-.517.219.798.798 0 01-.535-.24.745.745 0 01.01-1.062l1.646-1.646zm3.75-5l1.667 1.667a.733.733 0 010 1.062.733.733 0 01-1.063 0L9.521 8.021a.756.756 0 01-.208-.525c0-.1.017-.194.052-.281a.691.691 0 01.156-.236l2.958-2.958a.729.729 0 01.531-.23.762.762 0 01.76.761.73.73 0 01-.228.531L11.875 6.75h5.375c.212 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219h-5.375z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default SwitcherIcon;
